<template>
  <article class="layout-section -align-side">
    <figure class="layout-section__figure" style="background-image: url('/')" />

    <section class="layout-section__content">
      <h2 class="layout-section__title">Développer une culture de formation en milieu de travail</h2>
      <p>
        Développés dans le cadre d’un projet soutenu par la Commission des partenaires du marché du travail (CPMT) et
        mené en partenariat avec la Fédération des chambres de commerce du Québec (FCCQ), les outils de la série Trucs
        et outils pour favoriser l’apprentissage visent à faire découvrir les bases de l’ingénierie de la formation à
        toute personne qui souhaite organiser des activités de formation centrées sur les apprenants adultes. Lire le
        rapport présenté à la CPMT concernant ce projet.
      </p>
    </section>
  </article>
</template>

<script>
export default {
  name: 'ResourcesTrainingIntro'
}
</script>
